<div class="p-fluid">
  <div *ngIf="props.label" class="b-f-radiobutton-label">
    <label *ngIf="props.label" [attr.for]="id" class="basin-mb-0"
      >{{ props.label
      }}<span *ngIf="props.required">
        {{ props.required ? '*' : '' }}
      </span>
    </label>
    <div
      *ngIf="props.tooltip"
      class="symbol-info b-f-radiobutton-tooltip tooltip-icon"
      [pTooltip]="props.tooltip"
    ></div>
  </div>
  <div
    *ngFor="
      let item of checkIfObservable(props.options)
        ? (props.options | async)
        : props.options;
      let i = index
    "
    class="p-field-radiobutton"
  >
    <p-radioButton
      [name]="field.key"
      [value]="item[props.valueProp ? props.valueProp : 'value']"
      [label]="item[props.labelProp ? props.labelProp : 'label']"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [inputId]="field.key + '_' + i"
      [id]="field.id + '_' + i"
      [styleClass]="props.styleClass"
      (keydown)="props.keydown ?? onKeyDown($event)"
    ></p-radioButton>
    <div
      *ngIf="item[props.tooltipProp ? props.tooltipProp : 'tooltip']"
      class="symbol-info tooltip-icon"
      [pTooltip]="item[props.tooltipProp ? props.tooltipProp : 'tooltip']"
    ></div>
  </div>
</div>
